import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { HELP_DOCUMENT_API } from "./apiRoutes";

const getHelpDocuments = async () =>
  await axiosAuth.get(`${HELP_DOCUMENT_API}`);

const useGetHelpDocuments = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["help-documents"],
    queryFn: () => getHelpDocuments(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetHelpDocuments;
